import React, { Component } from 'react';
import { connect } from 'react-redux';
import OnboardingStep1 from './onboardingStep1';
import OnboardingStep2 from './onboardingStep2';
import OnboardingStep3 from './onboardingStep3';
import OnboardingStepTemplate from './onboardingStepTemplate';
import {
  updateOnBoardingDetails,
  updateUserDetails,
} from 'controllers/userController';
import Footer from 'common/footer/footer';
import TopBar from 'common/topBar/topBar';
class OnboardingContainer extends Component {
  componentDidMount() {
    const { history, profile } = this.props;
    if (!profile.userId || profile.onBoarded) {
      history.push('/login');
    }
  }
  onCLickNext = (page) => () => {
    const { history } = this.props;
    history.push(`${page}`);
  };

  onClickSave = async () => {
    const { history } = this.props;

    await updateUserDetails();
    history.push('/screened-pipe');
  };

  onChangeHandler = (e, forLocation) => {
    const arrayValues = ['perks', 'technologies', 'domains'];

    if (forLocation && forLocation.newValue) {
      updateOnBoardingDetails({ location: forLocation.newValue });
      return;
    }

    if (
      arrayValues.includes(e.target.name) &&
      e.target.value.trim().substr(-1) !== ','
    ) {
      const value = e.target.value.split(',').filter((value) => value);

      updateOnBoardingDetails({ [e.target.name]: value });
    } else {
      updateOnBoardingDetails({ [e.target.name]: e.target.value });
    }
  };

  renderScreen = () => {
    const { params } = this.props.match;
    const {
      organizationName,
      domains,
      technologies,
      foundedYear,
      companySize,
      aboutCompany,
      websiteLink,
      linkedinLink,
      location,
      perks,
    } = this.props.profile.organizationInfo;
    const { userName } = this.props.profile;

    if (params.step === '2') {
      return (
        <OnboardingStep2
          foundedYear={foundedYear}
          companySize={companySize}
          aboutCompany={aboutCompany}
          websiteLink={websiteLink}
          linkedinLink={linkedinLink}
          location={location}
          onChange={this.onChangeHandler}
          onCLickNext={this.onCLickNext}
        />
      );
    }

    if (params.step === '3') {
      return (
        <OnboardingStep3
          perks={perks}
          onChange={this.onChangeHandler}
          onClickSave={this.onClickSave}
          onCLickNext={this.onCLickNext}
        />
      );
    }

    return (
      <OnboardingStep1
        organizationName={organizationName}
        domains={domains}
        technologies={technologies}
        userName={userName}
        onCLickNext={this.onCLickNext}
        onChange={this.onChangeHandler}
      />
    );
  };

  render() {
    const { step = 1 } = this.props.match.params;

    return (
      <>
        <TopBar />
        <OnboardingStepTemplate step={step}>
          <this.renderScreen />
        </OnboardingStepTemplate>
        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.user.details,
});

export default connect(mapStateToProps, null)(OnboardingContainer);
